<body id="style-2" class="back">
  <div class="header">
    <div class="container-fluid">
      <div class="row justify-content-between">
        <div class="col-lg-4">
          <div class="logo">
            <img
              src="{{ onPassiveBaseUrl }}onpassive(nov-26)/images/logo.png"
              alt="logo"
            />
          </div>
        </div>
        <div class="col-lg-5">
          <div class="social_box">
            <a
              href="http://onpassive.com/blog"
              target="_blank"
              rel="noopener"
              title="ONPASSIVE Blog"
            >
              <img
                src="{{ onPassiveBaseUrl }}onpassive(nov-26)/images/blog.png"
                alt="blog"
            /></a>
            <a
              href="https://www.facebook.com/ONPASSIVE/ONPASSIVE"
              target="_blank"
              rel="noopener"
              title="Facebook"
            >
              <img src="{{ onPassiveBaseUrl }}onpassive(nov-26)/images/fb.png"
              alt="facebook"
            /></a>
            <a
              href="https://twitter.com/ONPASSIVE"
              target="_blank"
              rel="noopener"
              ><img
                src="{{ onPassiveBaseUrl }}onpassive(nov-26)/images/twitter.png"
                alt="Twitter"
                title="Twitter"
            /></a>
            <a
              href="https://www.linkedin.com/company/onpassiveofficial/company/onpassiveofficial"
              target="_blank"
              rel="noopener"
              ><img
                src="{{ onPassiveBaseUrl }}onpassive(nov-26)/images/in.png"
                alt="LinkedIn"
                title="Linkedin"
            /></a>
            <a
              href="https://www.youtube.com/c/ONPASSIVEc/ONPASSIVE"
              target="_blank"
              rel="noopener"
              ><img
                src="{{ onPassiveBaseUrl }}onpassive(nov-26)/images/youtube.png"
                alt="YouTube"
                title="Youtube"
            /></a>
            <a
              href="https://www.instagram.com/ONPASSIVE/"
              target="_blank"
              rel="noopener"
              title="Instagram"
              ><img
                src="{{ onPassiveBaseUrl }}onpassive(nov-26)/images/insta.png"
                alt="insta"
            /></a>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="container-fluid mt-5">
    <div class="mid_box">
      <div class="row">
        <div class="col-lg-4">
          <div class="third_box">
            <h1>
              NEW REVOLUTIONIZED INTERNET MARKETING
              <span class="size3">SOLUTIONS</span>
            </h1>
            <p class="size4 mt-5">
              "Overcome the fear of going after the things you love", "Never let
              a dream go unfulfilled", "Keep your head high" - are some of the
              best advice we get from a lot of people but nobody tells you how
              to do it all. We at ONPASSIVE are dream driven and also have what
              it takes to get it all done. Implementing AI, we have some of the
              best business models designed just for you to make a difference in
              your life. Check us out.
            </p>
            <div class="box bg-2">
              <button
                class="
                  button
                  button--pipaluk
                  button--inverted
                  button--round-l
                  button--text-thick
                  button--text-upper
                "
              >
                <a
                  href="/registration/user?reg={{ userId }}"
                  name="regform"
                  target="_blank"
                  rel="noopener"
                  >Become A Founder Now</a
                >
              </button>
            </div>
          </div>
        </div>
        <div class="col-lg-4 right mob"></div>
        <div class="col-lg-4 right mob_top">
          <div class="sec_box">
            <div class="launching_box">
              <h1 class="size2">LAUNCHING SOON</h1>
              <p>
                Use the right <span>solutions</span> for the perfect launch of
                your business. Get in touch with us for a life changing
                opportunity.
              </p>
            </div>
            <div class="video_box acc_panel anim_in">
              <video
                id="my-video"
                class="video-js video-size w-100 h-auto"
                controls
                preload="auto"
                poster="{{ myLinksS3URL }}images/Image0231.png"
                data-setup="{}"
                autoplay="true"
                muted
              >
                <source
                  src="{{
                    myLinksS3URL
                  }}videos/Onpassive_launching_page_video2.mp4"
                  type="video/mp4"
                />
              </video>
            </div>
          </div>
        </div>
      </div>
      <hr />
    </div>
  </div>
</body>
